import { http } from "./common";

export const GetPatientDetails = async (claimId) => {
    const json = await http.get('/api/v1/PatientDetail/' + claimId);
    return json;
}

export const fetchResources = async (url, patiendId, cursor?) => {
    if(cursor){
        const json = await http.get(url + patiendId + cursor);
        return json;
    }
    else{
        const json = await http.get(url + patiendId);
        return json;
    }
}